import { createIcon } from '@chakra-ui/icons';

export const CalendarBlank = createIcon({
  displayName: 'CalendarBlank',
  viewBox: '0 0 12 12',
  path: [
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_915_4228)">
        <path
          d="M10.5 1.89347H9.75V1.29653C9.75 1.11182 9.67098 0.934683 9.53033 0.804077C9.38968 0.673471 9.19891 0.600098 9 0.600098C8.80109 0.600098 8.61032 0.673471 8.46967 0.804077C8.32902 0.934683 8.25 1.11182 8.25 1.29653V1.89347H3.75V1.29653C3.75 1.11182 3.67098 0.934683 3.53033 0.804077C3.38968 0.673471 3.19891 0.600098 3 0.600098C2.80109 0.600098 2.61032 0.673471 2.46967 0.804077C2.32902 0.934683 2.25 1.11182 2.25 1.29653V1.89347H1.5C1.10218 1.89347 0.720644 2.04021 0.43934 2.30142C0.158035 2.56263 0 2.91691 0 3.28632L0 9.55418C0 9.92359 0.158035 10.2779 0.43934 10.5391C0.720644 10.8003 1.10218 10.947 1.5 10.947H10.5C10.8978 10.947 11.2794 10.8003 11.5607 10.5391C11.842 10.2779 12 9.92359 12 9.55418V3.28632C12 2.91691 11.842 2.56263 11.5607 2.30142C11.2794 2.04021 10.8978 1.89347 10.5 1.89347ZM1.5 9.55418V4.67918H10.5V9.55418H1.5Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_915_4228">
          <rect width="12" height="11.1429" fill="white" transform="translate(0 0.428467)" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
